import { Trans } from 'react-i18next';

import Button from '../../../../../../components/buttons/Button';
import type { MetagameBingoEvent } from '../../../../../../stores/bingo/types';
import { useBingoWidgetCallbacks } from '../../../../hooks';
import { BingoLiveButtonText } from '../../BingoLiveButtonText/BingoLiveButtonText';
import { BingoWidgetLogo } from '../../BingoWidgetLogo/BingoWidgetLogo';
import { BingoWideWidgetWrapper } from '../BingoWideWidgetWrapper/BingoWideWidgetWrapper';

import styles from './BingoLiveWideWidget.module.scss';

interface BingoLiveWideWidgetProps {
  event: MetagameBingoEvent;
}

export function BingoLiveWideWidget(props: BingoLiveWideWidgetProps) {
  const { event } = props;
  const { onEnterLiveEventClick } = useBingoWidgetCallbacks();
  const feature = event?.game.isFreeDaubEvent ? 'daub' : 'general';
  const bingoType = event?.coinType === 'GC' ? 'CASUAL' : 'SWEEP';

  return (
    <BingoWideWidgetWrapper
      dataTestId="bingo-live-wide-widget"
      feature={feature}
      wrapperClassName={styles.wrapper}
      onClick={() => onEnterLiveEventClick(event)}
    >
      <BingoWidgetLogo bingoType={bingoType} sizeType="wide" />
      <div className={styles.content}>
        <div className={styles.topWrapper}>
          <span className={styles.text} data-testid="bingo-live-widget-text">
            <Trans
              components={{ bold: <span className={bingoType === 'SWEEP' ? styles.textSweep : styles.textCasual} /> }}
              i18nKey={bingoType === 'SWEEP' ? 'prime.bingo.sweepBingoIsLive' : 'prime.bingo.ccBingoIsLive'}
            />
          </span>
        </div>
        <div className={styles.btnWrapper}>
          <Button btnType="purple-blue" className={styles.btn} dataTestId="bingo-live-wide-widget-btn">
            <BingoLiveButtonText />
          </Button>
        </div>
      </div>
    </BingoWideWidgetWrapper>
  );
}
